import Slider from '@mui/material/Slider';
import PropTypes from 'prop-types';

import { GREY, PRIMARY } from '@/constants/color';
import { numberToUsd } from '@/helpers/valueFormatter/numberFormatter.helpers';
import { useMemo } from 'react';

const EstimationSlider = ({ disabled = false, value, handleChange, maxValue, minValue, useValueConverter }) => {
  const convertValue = useMemo(
    () =>
      useValueConverter
        ? sliderValue => numberToUsd(sliderValue, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        : value => value,
    [useValueConverter],
  );

  return (
    <div className='flex justify-center items-center gap-x-2 w-full border px-3 pt-2 pb-1.5 mt-2 mb-2 rounded-[4px]'>
      <span className={`-mt-1.5 mr-2 font-semibold text-sm text-[${GREY}]`}>{convertValue(minValue)}</span>
      <div className='w-full'>
        <Slider
          value={value}
          onChange={handleChange}
          valueLabelDisplay='auto'
          min={minValue}
          max={maxValue}
          step={1}
          valueLabelFormat={convertValue}
          getAriaValueText={convertValue}
          disabled={disabled}
          sx={{
            '& .MuiSlider-track': {
              border: '4px solid transparent',
              borderRadius: 4,
              borderColor: PRIMARY,
            },
            '& .MuiSlider-rail': {
              border: '4px solid transparent',
              borderRadius: 4,
            },
            '& .MuiSlider-thumb': {
              width: 28,
              height: 28,
              boxShadow: 'none',
              filter:
                'drop-shadow(0px 23px 44px rgba(176, 183, 195, 0.14)) drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.12)) drop-shadow(0px 8px 16px rgba(27, 67, 50, 0.16))',
              backgroundColor: 'white',
              '&:hover, &.Mui-focusVisible': {
                boxShadow: 'none',
              },
              '&::before': {
                content: '""',
                display: 'block',
                width: 12,
                height: 12,
                backgroundColor: PRIMARY,
                borderRadius: '50%',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              },
            },
          }}
        />
      </div>
      <span className={`-mt-1.5 ml-2 font-semibold text-sm text-[${GREY}]`}>{convertValue(maxValue)}</span>
    </div>
  );
};

EstimationSlider.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.number.isRequired,
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  useValueConverter: PropTypes.bool,
};

export default EstimationSlider;
